import { CardStatuses, CardStatusesTranslations } from "@/modules/card/common/enum";
import { useGetCardStatusQuery } from "@/modules/card/services";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { Loader } from "@ab.uitools/ui-library/helperComponents";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  cardId: number;
  className?: string;
}

export const CardStatus = ({ cardId, className = "" }: Props) => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetCardStatusQuery({ cardId });

  const status = useMemo(() => {
    if (data === CardStatuses.Blocked) {
      return CardStatusesTranslations.Blocked;
    }
    if (data === CardStatuses.NotActive) {
      return CardStatusesTranslations.NotActive;
    }
    return "";
  }, [data]);

  return (
    <div className={className}>
      {isFetching ? (
        <Loader size="small" type="dark"/>
      ) : (
        <Text type="danger-dark">{t(status)}</Text>
      )}
    </div>
  );
};
